import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/caprock/front-images/user.png'


const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex justify-content-start py-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "d-flex" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey p-cursor" }, [
        /*#__PURE__*/_createElementVNode("img", {
          style: {"width":"50px","height":"50px","object-fit":"cover","border-radius":"50%","margin":"0 15px 0 0"},
          onerror: "this.src='../../assets/caprock/front-images/user.png';",
          src: _imports_0
        }),
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#6B7A99"} }, "My Beneficiary")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex justify-content-center align-items-center py-4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex justify-content-end align-items-center py-4" })
], -1)
const _hoisted_7 = { class: "row my-3 justify-content-center" }
const _hoisted_8 = { class: "col-md-12 px-5 pt-4" }
const _hoisted_9 = { class: "p-4 mb-4 bg-card-light border-radius-10 h-100" }
const _hoisted_10 = { class: "row mt-3 mx-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex justify-content-between mb-2" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-14" }, [
      /*#__PURE__*/_createElementVNode("b")
    ])
  ])
], -1)
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"row my-3 mx-1\"><div class=\"col-md-1\"><label class=\"font-grey mx-2\">No</label></div><div class=\"col-md-7\"><label class=\"font-grey mx-2\">Beneficiary Name</label></div><div class=\"col-md-3\"><label class=\"font-grey mx-2\">Type</label></div><div class=\"col-md-1\"><label class=\"font-grey mx-2\">Action</label></div></div>", 1)
const _hoisted_14 = {
  key: 0,
  id: "results"
}
const _hoisted_15 = { class: "col-md-1" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "beneficiary_tag" }
const _hoisted_18 = { class: "col-md-7" }
const _hoisted_19 = {
  class: "form-group",
  style: {"overflow":"auto"}
}
const _hoisted_20 = { class: "beneficiary_tag" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "beneficiary_tag" }
const _hoisted_24 = { class: "col-md-1" }
const _hoisted_25 = { class: "form-group text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"18px","color":"#005288","font-weight":"bolder","writing-mode":"vertical-rl","text-orientation":"sideways","margin-top":"15px"},
  class: "p-cursor dropdown-toggle",
  id: "datatoggle",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " ... ", -1)
const _hoisted_27 = {
  class: "dropdown-menu",
  "aria-labelledby": "datatoggle"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  id: "results"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "beneficiary_tag text-center font-grey font-size-14" }, "No Data Found !!", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade sending_email",
  id: "sending_email",
  role: "dialog"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-sm modal-dialog-centered",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content bg-light" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row mx-1 mt-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
            /*#__PURE__*/_createElementVNode("p", null, "Sending document to your mail ! Please Wait.....")
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_beneficiary = _resolveComponent("beneficiary", true)!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("input", {
                          onKeyup: _cache[0] || (_cache[0] = ($event: any) => {_ctx.textSearch($event);}),
                          style: {"border":"1px solid grey !important","height":"35px","float":"right","border-radius":"5px !important"},
                          type: "text",
                          id: "doc_search_input",
                          placeholder: "Search beneficiary name here..",
                          class: "bg-white w-100 pl-3"
                        }, null, 32)
                      ])
                    ]),
                    _hoisted_13,
                    (_ctx.beneficiaries.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.beneficiaries, (beneficiary) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: beneficiary.beneficiary_id,
                              class: "row my-1 mx-1 docss"
                            }, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("p", _hoisted_17, [
                                    _createElementVNode("span", null, _toDisplayString(beneficiary.no), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("p", _hoisted_20, _toDisplayString(beneficiary.beneficiary_name), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("p", _hoisted_23, _toDisplayString(beneficiary.beneficiary_type.toUpperCase()), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  _hoisted_26,
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item pl-2",
                                      onClick: ($event: any) => {_ctx.view_beneficiary(beneficiary.beneficiary_id);},
                                      href: "#"
                                    }, " • Edit", 8, _hoisted_28)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.beneficiaries.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_32,
    _createVNode(_component_beneficiary, {
      ref: "bnF",
      beneficiary_id: _ctx.beneficiary_id,
      beneficiary_on: _ctx.beneficiary_on,
      countries: _ctx.countries,
      reload_b: _ctx.reload_b
    }, null, 8, ["beneficiary_id", "beneficiary_on", "countries", "reload_b"]),
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}